'use server'

import { apiRequest, ApiResponse } from '../request'

export interface DocumentSigner {
    id: number
    signDocumentId: number
    signerId?: string
    name: string
    email: string
    partnerId?: number
    clientId?: number
    status: 'WAITING' | 'SIGNED'
    type: 'PARTNER' | 'CLIENT' | 'OTHER'
    partner?: { id: number; name: string; tradingName?: string }
    client?: { id: number; name: string; email?: string }
    createdAt: string
    updatedAt: string
}

export interface SignDocument {
    id: number
    companyId: number
    partnerId?: number | null
    origin?: string | null
    originId?: number
    description?: string
    documentUrl?: string
    signedDocumentUrl?: string
    envelopeId?: string
    status: 'PENDING' | 'SENT' | 'SIGNING' | 'COMPLETED' | 'CANCELLED'
    signers: DocumentSigner[]
    createdAt: string
    updatedAt: string
}

export interface SendSignDocumentSigner {
    name: string
    email: string
    partnerId?: number
    clientId?: number
    type?: 'PARTNER' | 'CLIENT' | 'OTHER'
}

export interface SendSignDocumentData {
    origin: string
    originId?: number
    description?: string
    signers: SendSignDocumentSigner[]
}

export interface CreateSignDocumentData {
    origin?: string
    originId?: number
    description?: string
}

export interface SendExistingDocumentData {
    signers: SendSignDocumentSigner[]
}

// --- Sign Documents ---

export async function getSignDocuments(
    companyId: number,
    params?: { page?: number; limit?: number; status?: string; origin?: string; partnerId?: number },
): Promise<ApiResponse<SignDocument[]>> {
    return apiRequest<SignDocument[]>(`sign/company/${companyId}`, {
        params,
    })
}

export async function getSignDocument(
    id: number,
): Promise<ApiResponse<SignDocument>> {
    return apiRequest<SignDocument>(`sign/${id}`, {})
}

export async function createSignDocument(
    formData: FormData,
): Promise<ApiResponse<SignDocument>> {
    return apiRequest<SignDocument>('sign/upload', { data: formData, formData: true }, 'post')
}

export async function addSignDocumentSigner(
    documentId: number,
    data: SendSignDocumentSigner,
): Promise<ApiResponse<DocumentSigner>> {
    return apiRequest<DocumentSigner>(`sign/${documentId}/signers`, { data }, 'post')
}

export async function removeSignDocumentSigner(
    documentId: number,
    signerId: number,
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`sign/${documentId}/signers/${signerId}`, {}, 'delete')
}

export async function sendSignDocumentForSigning(
    id: number,
): Promise<ApiResponse<SignDocument>> {
    return apiRequest<SignDocument>(`sign/${id}/send`, {}, 'post')
}

export async function sendSignDocument(
    formData: FormData,
): Promise<ApiResponse<SignDocument>> {
    return apiRequest<SignDocument>('sign/send', { data: formData, formData: true }, 'post')
}

export async function deleteSignDocument(
    id: number,
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`sign/${id}`, {}, 'delete')
}
